var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#09C97F",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6118 15.5559L27.2542 18.868C27.4782 19.3291 28.0755 19.7713 28.5795 19.856L31.5564 20.3547C33.4603 20.6746 33.9083 22.0672 32.5364 23.441L30.222 25.7745C29.83 26.1697 29.6154 26.9319 29.7366 27.4777L30.3993 30.3663C30.9219 32.6528 29.718 33.5373 27.7116 32.3423L24.9212 30.6768C24.4173 30.3758 23.5867 30.3758 23.0734 30.6768L20.2831 32.3423C18.2859 33.5373 17.0728 32.6434 17.5954 30.3663L18.258 27.4777C18.3793 26.9319 18.1646 26.1697 17.7727 25.7745L15.4583 23.441C14.0957 22.0672 14.5344 20.6746 16.4382 20.3547L19.4152 19.856C19.9098 19.7713 20.507 19.3291 20.731 18.868L22.3735 15.5559C23.2694 13.7587 24.7252 13.7587 25.6118 15.5559Z",
    stroke: "#43AF87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.aea86ff11a9d1a5a636e0bef9f7cf494.svg";
export { ForwardRef as ReactComponent };